import auth from './auth'

export default router => {
  router.beforeEach(auth)
}
